import React, { useState } from "react";
import PropTypes from "prop-types";

import {
  Section,
  Container,
  Columns,
  Button,
  Form,
  Notification,
} from "react-bulma-components";

import VideoRoom from "../VideoRoom/VideoRoom";

import AppContainer from "./AppContainer";
import { FC } from "react";

const App: FC<{
  videoRoom: any;
  userName: string;
  roomName: string;
  isJoining: boolean;
  isVideoSupported: boolean;
  isScreenSharingSupported: boolean;
  isScreenSharingEnabled: boolean;
  canJoin: boolean;
  onJoin: () => void;
  onLeave: () => void;
  onShare: () => void;
  handleMuteChange?: (mute: boolean) => void;
  handleVideoChange?: (mute: boolean) => void;
  onUserNameChange: () => void;
  onRoomNameChange: () => void;
  errorMessage?: string;
  onErrorMessageHide: () => void;
}> = ({
  videoRoom = null,
  userName,
  roomName,
  isJoining,
  isVideoSupported,
  isScreenSharingSupported,
  isScreenSharingEnabled,
  onLeave,
  onShare,
  handleMuteChange,
  handleVideoChange,
  errorMessage = null,
  onErrorMessageHide,
}) => {
  let content = null;

  const [isMuted, setMuted] = useState(false);
  const [isVideoPaused, setVideoPaused] = useState(true);
  if (!isVideoSupported) {
    content = <div>Video is not supported</div>;
  } else {
    content = videoRoom ? (
      <>
        {<VideoRoom videoRoom={videoRoom} />}

        <div className="video-actions">
          <Button
            className="beam-btn ml-2"
            onClick={() => {
              handleMuteChange(!isMuted);
              setMuted(!isMuted);
            }}
          >
            {!isMuted ? (
              <img className="action-icon" src="/images/unmuted-icon.png" />
            ) : (
              <img className="action-icon" src="/images/muted-icon.png" />
            )}
          </Button>
          <Button
            className="beam-btn ml-2"
            onClick={() => {
              handleVideoChange(!isVideoPaused);
              setVideoPaused(!isVideoPaused);
            }}
          >
            {!isVideoPaused ? (
              <img
                className="action-icon"
                src="/images/resume-video-icon.png"
              />
            ) : (
              <img className="action-icon" src="/images/pause-video-icon.png" />
            )}
          </Button>
          <Button
            className="beam-btn ml-2"
            disabled={!isScreenSharingSupported}
            onClick={() => onShare()}
          >
            {isScreenSharingEnabled ? (
              <img
                className="action-icon"
                src="/images/stop-screen-share.png"
              />
            ) : (
              <img
                className="action-icon"
                src="/images/screen-share-icon.png"
              />
            )}
          </Button>
          <Button className="beam-btn ml-2" onClick={() => onLeave()}>
            <img className="action-icon" src="/images/end-call.png" />
          </Button>
        </div>
      </>
    ) : isJoining ? (
      <div className="page-alert">
        <h4>Starting Call</h4>
        <p>Please wait...</p>
      </div>
    ) : (
      <div className="page-alert">
        <h4>Call Ended</h4>
      </div>
    );
  }

  return (
    <Section>
      <div>
        <h1>{roomName}</h1>
        {errorMessage && (
          <Notification color="danger">
            Error: {errorMessage}
            <Button onClick={onErrorMessageHide} remove />
          </Notification>
        )}
        {content}
      </div>
    </Section>
  );
};

const render = (containerProps) => <App {...containerProps} />;
export default (props) => <AppContainer render={render} {...props} />;
